import React from "react";

import { differenceInDays } from "date-fns";

import useStyles from "./styles";

interface BookedByDateProps {
  value: string;
}

export const BookedByDate = ({ value }: BookedByDateProps) => {
  const classes = useStyles();

  if (!value) return null;

  const DIFFERENCE_ALERT = 11;
  const todayString = new Date().toISOString();
  const todayArray = todayString.split("T");
  const finalDate = new Date(`${todayArray[0]}T00:00:00.00+00:00`);
  const shipByDate = new Date(value).toISOString();
  let bookDifference = differenceInDays(Date.parse(shipByDate), finalDate);

  if (bookDifference <= 0) bookDifference = 0;

  return (
    <span className={bookDifference <= DIFFERENCE_ALERT ? classes.bookDifferenceColor : undefined}>
      {bookDifference}
    </span>
  );
};
